// src/components/Loader.js
import React from "react";

function Loader({ message = "Loading..." }) {


    return (
        <div className="d-flex justify-content-center align-items-center vh-100 flex-column">
            {/* Spinner */}
            <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">{message}</span>
            </div>
            {/* Text */}
            <p className="fw-semibold text-muted">{message}</p>
        </div>
    );


}

export default Loader;
